import type { BillingPlan, BillingPlanTier } from '@recruitee/products-types';

import type { ProductStatus } from '../plan-picker.types';

export type Product = {
  plan: BillingPlan | undefined;
  costPerMonth: number | null;
  costPerYear: number | null;
  status: ProductStatus;
};

export type Products = {
  [BillingPlanTier.Start]: Product;
  [BillingPlanTier.Grow]: Product;
  [BillingPlanTier.Optimize]: Product;
};

export enum ViewMode {
  Default,
  StaffingAgency,
  Migration,
}
